<span class="menu">
  <button type="button" class="main-menu menu-button" (click)="open()"></button>
  <div class="menu-contents scrollable-content scrollable-content-y">
    <div class="menu-item">
      <img
        class="logo"
        [ngClass]="'logo--' + mainLogo.name"
        [src]="brand.mainLogo()"
      />
    </div>

    <fieldset class="menu-group">
      <ul>
        <li (click)="updateStrategiesGridVis(true)" class="menu-group-item">
          Strategies
        </li>
        <li (click)="updatePositionGrid(true)" class="menu-group-item">
          Positions
        </li>
      </ul>
      <legend>Strategies and Positions</legend>
    </fieldset>

    <fieldset class="menu-group" [ngClass]="{ hide: !showToolsList }">
      <ul id="toolsList">
        @if (showAdmin) {
          <li routerLink="/admin" class="menu-group-item">Admin</li>
        }

        @if (showPerseusAdmin) {
          <li routerLink="/perseus-admin" class="menu-group-item">
            Perseus Admin
          </li>
        }

        @if (showMarketDataUpdates) {
          <li (click)="openMarketData($event)" class="menu-group-item">
            Market Data Updates
          </li>
        }

        @if (showMonitor) {
          <li routerLink="/monitor" class="menu-group-item">Monitoring</li>
        }

        @if (isDciGridAccessAuthorized) {
          <li (click)="showDciGrid()" class="menu-group-item">DCI Grid</li>
        }

        @if (scheduleReportsEnabled) {
          <li (click)="setShowScheduleReports(true)" class="menu-group-item">
            Schedule Reports
          </li>
        }

        @if (alertsEnabled) {
          <li class="menu-group-item" (click)="setShowAlerts(true)">Alerts</li>
        }
      </ul>
      <legend>Tools</legend>
    </fieldset>

    <fieldset
      class="menu-group"
      [ngClass]="{ hide: !showPricingEnviromentList }"
    >
      <ul id="pricingEnviromentList">
        @if (isEntitiesReadAccessAuthorized) {
          <li (click)="setShowEntities(true)" class="menu-group-item">
            Entities
          </li>
        }

        @if (creditCurvesEnabled) {
          <li (click)="setShowCreditCurves(true)" class="menu-group-item">
            Credit Curves
          </li>
        }

        @if (csaEnabled) {
          <li (click)="setShowCsa(true)" class="menu-group-item">CSAs</li>
        }

        @if (isTreasuryCurvesReadAccessAuthorized) {
          <li (click)="setShowTreasuryCurves(true)" class="menu-group-item">
            Treasury Curves
          </li>
        }

        @if (isFixingsReadAccessAuthorized) {
          <li (click)="setShowFixings(true)" class="menu-group-item">
            Fixings
          </li>
        }

        @if (isFixingsReadAccessAuthorized) {
          <li (click)="openIRFixingSources(true)" class="menu-group-item">
            IR Fixings
          </li>
        }

        @if (showCreditLines) {
          <li (click)="setShowCreditLines(true)" class="menu-group-item">
            Credit Lines
          </li>
        }

        @if (showUserManagement) {
          <li
            (click)="setWarningModalSettings('userManagement')"
            class="menu-group-item"
          >
            User Management
          </li>
        }

        @if (showWhiteLabelTradingRules) {
          <li
            (click)="setWarningModalSettings('whiteLabelTradingRules')"
            class="menu-group-item"
          >
            White Label Trading Rules
          </li>
        }

        @if (showManageStaticData) {
          <li
            (click)="setWarningModalSettings('manageStaticData')"
            class="menu-group-item"
          >
            Manage Static Data
          </li>
        }
      </ul>
      <legend>Pricing Environment</legend>
    </fieldset>

    <fieldset
      id="marketDataList"
      class="menu-group"
      [ngClass]="{ hide: !showMarketDataList }"
    >
      <ul>
        @if (isVolSurfaceReadAccessAuthorized) {
          <li (click)="updateVolVis()" class="menu-group-item">
            Volatility Surface
          </li>
        }
        @if (isForwardCurveReadAccessAuthorized) {
          <li (click)="updateForwardVis()" class="menu-group-item">
            Forward Curve
          </li>
        }
        <!-- This is broken, so we're hiding it for now -->
        <!-- <li (click)="updateHistoricalGraphVis()" class="menu-group-item">
          Historical Graph
        </li> -->
      </ul>
      <legend>Market Data</legend>
    </fieldset>

    @if (isDefinitionsReadAccessAuthorized) {
      <fieldset class="menu-group">
        <ul>
          <li class="menu-group-item" (click)="openCurrencyPairs()">
            Currency Pairs
          </li>
          <li class="menu-group-item" (click)="openFixingSources()">
            Fixing Sources
          </li>
          <li class="menu-group-item" (click)="openTradeStatus()">
            Trade Status
          </li>
          <li class="menu-group-item" (click)="openCutoffs()">Cuts</li>
        </ul>
        <legend>Display Definitions</legend>
      </fieldset>
    }

    @if (showUserManualLink) {
      <fieldset class="menu-group">
        <legend>Resources</legend>
        <ul>
          <li class="menu-group-item" (click)="openHydraManual()">
            Hydra Manual
          </li>
        </ul>
      </fieldset>
    }

    <div class="menu-item" *ngIf="!!brand.poweredByLogo()">
      <img class="logo logo--powered-by" [src]="brand.poweredByLogo()" />
      <span></span>
    </div>

    <div class="menu-item">
      <div class="build-number">
        Build {{ buildNumber }}
        <span
          *ngIf="latestBuildNo && latestBuildNo !== buildNumber"
          class="latest-build"
        >
          [Latest {{ latestBuildNo }}]
        </span>
      </div>
    </div>
  </div>
</span>

<ui-modal
  [(isOpened)]="warningModalSettings.showModal"
  modalTitle="Changes might be lost"
  size="md"
>
  <div class="body">
    Trades may need to be saved prior to opening
    <span *ngIf="warningModalSettings.modal === 'userManagement'">
      user management
    </span>
    <span *ngIf="warningModalSettings.modal === 'manageStaticData'">
      static data management
    </span>
    <span *ngIf="warningModalSettings.modal === 'whiteLabelTradingRules'">
      white label trading rules
    </span>
    or changes may be lost.
  </div>
  <div class="footer-buttons">
    <button
      type="button"
      class="ui-button ui-button__footer usermgmt-continue"
      (click)="navigateUrlFromModal()"
    >
      Continue
    </button>
    <button
      type="button"
      class="ui-button ui-button__footer"
      (click)="warningModalSettings.showModal = false"
    >
      Cancel
    </button>
  </div>
</ui-modal>

<app-market-data
  [isModalOpened]="isMarketDataOpen"
  *ngIf="isMarketDataOpen"
  (modalStateChanged)="openMarketData($event)"
></app-market-data>
